import { loadSections } from '../components/layout/LoadSections'
import { setupAutoPostback } from '../forms/auto-postback'

export class ListPaging {
  constructor (elem) {
    this.elem = elem
    this.href = window.location.href

    if (this.elem.dataset.listCurrent) {
      this.href = this.elem.dataset.listCurrent
    }

    this.fetchUrl = this.href

    this.sort = ''
    this.isWidget = elem.dataset.listPaging === 'widget'

    if (this.isWidget) {
      this.fetchUrl = elem.dataset.listCurrent
    }

    this.setupLinks()
    this.setupForm()
  }

  setupForm () {
    const pageForm = this.elem.querySelector('[data-paging-form]')

    if (pageForm) {
      pageForm.addEventListener('submit', (e) => {
        e.preventDefault()
        pageForm.validator.validateForm().then((formData) => {
          const kvpairs = []
          for (const entry of formData.entries()) {
            if (entry[1] != null && entry[1].toString().length > 0) {
              kvpairs.push(encodeURIComponent(entry[0]).toLowerCase() + '=' + encodeURIComponent(entry[1]).toLowerCase())
            }
          }
          const queryString = kvpairs.join('&')
          if (queryString.length > 0) {
            this.href = pageForm.action + '?' + queryString
          } else {
            this.href = pageForm.action
          }

          this.fetchUrl = this.href

          this.navigate()
        }).catch(errors => {
          console.log(errors)
        })
      })
    }
  }

  setupLinks () {
    const pageLinks = this.elem.querySelectorAll('[data-paging] a')

    if (pageLinks) {
      for (const pageLink of pageLinks) {
        pageLink.addEventListener('click', (e) => {
          e.preventDefault()
          const href = new URL(pageLink.href)
          let fetchHref
          if (this.isWidget) {
            fetchHref = pageLink.dataset.url
          } else {
            fetchHref = href

            if (this.sort.length > 0) {
              href.searchParams.set('sort', this.sort)
            }
          }

          this.href = href.toString()
          this.fetchUrl = fetchHref.toString()
          this.navigate()
        })
      }
    }

    const sort = this.elem.querySelector('[data-sort]')
    if (sort) {
      if (this.sort.length > 0) {
        const href = new URL(this.href)
        sort.value = href.searchParams.get('sort')
      }

      sort.addEventListener('change', (e) => {
        this.sort = e.target.value
        const href = new URL(this.href)
        if (href.searchParams.has('page')) {
          href.searchParams.delete('page')
        }
        href.searchParams.set('sort', this.sort)
        this.href = href.toString()

        if (this.isWidget) {
          const fhref = new URL(this.fetchUrl)
          fhref.searchParams.set('sort', this.sort)
          if (fhref.searchParams.has('page')) {
            fhref.searchParams.delete('page')
          }
          this.fetchUrl = fhref.toString()
        } else {
          this.fetchUrl = this.href
        }
        this.navigate()
      })
    }
  }

  navigate () {
    const options = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    fetch(this.fetchUrl, options).then((response) => {
      return response.text()
    }).then((data) => {
      this.updateHistory(data, this.href)
      this.updateContents(data)
      window.scrollTo({
        top: this.elem.offsetTop - 150,
        behavior: 'smooth'
      })
      this.setupLinks()
      this.setupForm()

      const event = new CustomEvent('form-updated', { bubbles: true })
      this.elem.dispatchEvent(event)
      setupAutoPostback(this.elem)
    })
  }

  updateHistory (data, url) {
    if (window.history) {
      history.replaceState(data, document.title, url)
    }
  }

  updateContents (data) {
    this.elem.style.height = `${this.elem.offsetHeight}px`

    this.elem.innerHTML = data
    loadSections(this.elem)

    window.setTimeout(() => this.elem.style.removeProperty('height'), 1)
  }
}

export const setupListPaging = function () {
  const lists = document.querySelectorAll('[data-list-paging]')
  const pagingLists = []
  for (let i = 0; i < lists.length; i++) {
    pagingLists.push(new ListPaging(lists[i]))
  }
}
